import { render } from "./Joblist.vue?vue&type=template&id=2fa7bdae&scoped=true"
import script from "./Joblist.vue?vue&type=script&lang=js"
export * from "./Joblist.vue?vue&type=script&lang=js"

import "./Joblist.vue?vue&type=style&index=0&id=2fa7bdae&scoped=true&lang=css"

import exportComponent from "/home/trit/trit/dev/caspwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa7bdae"]])

export default __exports__